module.exports = __webpack_public_path__ + "static/media/req.16622bf2.svg";